export default function () {
  return {
    currentCompany: null,
    timezones: []
  }
}
